import React, { CSSProperties } from 'react'
import { Spin } from 'antd'
import styled from '@emotion/styled'
import { Text } from '@organice/atoms/text'

interface LoadingIndicator {
  isLocal?: boolean
  message?: string
  style?: CSSProperties
}

export const LoadingIndicator: React.FC<LoadingIndicator> = ({
  isLocal,
  message,
  style = {},
}) => (
  <Wrapper
    style={
      isLocal
        ? style
        : {
            ...style,
            position: 'fixed',
            width: '100vw',
            height: '100vh',
            // transform: 'translateX(-50%)',
          }
    }
  >
    <Content>
      <Spin />
      {message && <Text>{message}</Text>}
    </Content>
  </Wrapper>
)

export const LoadingIndicatorSkeleton: React.FC<LoadingIndicator> = ({
  isLocal,
  message,
  style = {},
}) => (
  <Wrapper
    style={
      isLocal
        ? style
        : {
            ...style,
            position: 'fixed',
            width: '100vw',
            height: '100vh',
            // transform: 'translateX(-50%)',
          }
    }
  >
    <Content>
      <DotsContainer>
        <Dot />
        <Dot />
        <Dot />
      </DotsContainer>
      {message && <Text>{message}</Text>}
    </Content>
  </Wrapper>
)

const Wrapper = styled.div`
  position: relative;
  top: 50%;
  // left: 50%;
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`
const DotsContainer = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`

const Dot = styled.div`
  width: 8px;
  height: 8px;
  background-color: #d9d9d9;
  border-radius: 50%;
  animation: pulse 1.5s ease-in-out infinite;

  &:nth-of-type(2) {
    animation-delay: 0.3s;
  }

  &:nth-of-type(3) {
    animation-delay: 0.6s;
  }

  @keyframes pulse {
    0%,
    80%,
    100% {
      opacity: 0.3;
    }
    40% {
      opacity: 1;
    }
  }
`
